import { useState } from 'react'
import {
  Button,
  Divider,
  Input,
  Typography,
  Select,
  Form,
  message,
  Switch,
} from 'antd'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { ACCESS_LEVELS, gameComplexity, gameMonetizationModel, gameTier, retentionDepth } from 'src/constants'
import { saveEditTreasureHunter } from 'src/api/treasurehunter'
import './EditTreasureHunter.css'

const { Title, Text } = Typography

const EditTreasureHunter = () => {
  const { id } = useParams()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const navigate = useNavigate()
  const [form] = Form.useForm()

  const [accessLevels, setAccessLevels] = useState(
    params.getAll('accessLevels')
  )
  const [enabled, setEnabled] = useState(params.get('enabled') === 'true')
  const [newImage, setNewImage] = useState(null)
  const [newThumbImage, setNewThumbImage] = useState(null)
  const [editedImg, setEditedImg] = useState(params.get('img'))
  const [editedThumbImg, setEditedThumbImg] = useState(
    params.get('thumbnailImage')
  )

  const handleImageUpload = (event) => {
    const file = event.target.files?.[0]
    if (file) {
      setNewImage(file)
      setEditedImg(URL.createObjectURL(file))
    }
  }

  const handleThumbImageUpload = (event) => {
    const file = event.target.files?.[0]
    if (file) {
      setNewThumbImage(file)
      setEditedThumbImg(URL.createObjectURL(file))
    }
  }

  const handleAccessLevelChange = (value) => {
    setAccessLevels(value)
  }

  const onChangeSwitch = (checked) => {
    setEnabled(checked)
  }

  const handleSave = async () => {
    const values = await form.validateFields()
    await saveEditTreasureHunter(
      id,
      values.editedTitle,
      values.editedDesc,
      values.editedInstruction,
      values.editedTitleFr,
      values.editedDescFr,
      values.editedInstructionFr,
      values.editedTitleAr,
      values.editedDescAr,
      values.editedInstructionAr,
      newImage,
      newThumbImage,
      accessLevels,
      enabled,
      values.editedComplex,
      values.editedRetentionDepth,
      values.editedMonetizationModel,
      values.editedTier
    )
    navigate('/games')
  }

  const onCancel = () => {
     navigate('/games')
  }

  return (
    <div className="edit-treasure-hunter-container">
      <Title level={3}>
        <Text>Edit Treasure Hunter</Text>
      </Title>
      <Divider />
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          editedTitle: params.get('title'),
          editedDesc: params.get('desc'),
          editedInstruction: params.get('instruction'),
          editedTitleFr: params.get('titleFr'),
          editedDescFr: params.get('descFr'),
          editedInstructionFr: params.get('instructionFr'),
          editedTitleAr: params.get('titleAr'),
          editedDescAr: params.get('descAr'),
          editedInstructionAr: params.get('instructionAr'),
          accesslevel: accessLevels,
          enabled: enabled,
        }}
      >
        <Form.Item
          name="editedTitle"
          label="Title"
          rules={[{ required: true }]}
        >
          <Input placeholder="Title" />
        </Form.Item>
        <Form.Item
          name="editedDesc"
          label="Description"
          rules={[{ required: true }]}
        >
          <Input.TextArea placeholder="Description" />
        </Form.Item>
        <Form.Item
          name="editedInstruction"
          label="Instruction"
          rules={[{ required: true }]}
        >
          <Input.TextArea placeholder="Instruction" />
        </Form.Item>

        <Divider>French</Divider>
        <Form.Item
          name="editedTitleFr"
          label="Title Fr"
          rules={[{ required: true }]}
        >
          <Input placeholder="Title Fr" />
        </Form.Item>
        <Form.Item
          name="editedDescFr"
          label="Description Fr"
          rules={[{ required: true }]}
        >
          <Input.TextArea placeholder="Description Fr" />
        </Form.Item>
        <Form.Item
          name="editedInstructionFr"
          label="Instruction Fr"
          rules={[{ required: true }]}
        >
          <Input.TextArea placeholder="Instruction Fr" />
        </Form.Item>
        <Divider>Arabic</Divider>
        <Form.Item
          name="editedTitleAr"
          label="Title Ar"
          rules={[{ required: true }]}
        >
          <Input placeholder="Title Ar" />
        </Form.Item>
        <Form.Item
          name="editedDescAr"
          label="Description Ar"
          rules={[{ required: true }]}
        >
          <Input.TextArea placeholder="Description Ar" />
        </Form.Item>
        <Form.Item
          name="editedInstructionAr"
          label="Instruction Ar"
          rules={[{ required: true }]}
        >
          <Input.TextArea placeholder="Instruction Ar" />
        </Form.Item>

        <Form.Item
          name="accesslevel"
          label="Access Level"
          rules={[{ required: true, message: 'Please select access level' }]}
        >
          <Select
            mode="multiple"
            allowClear
            placeholder="Select access level"
            options={ACCESS_LEVELS}
            onChange={handleAccessLevelChange}
          />
        </Form.Item>
<Form.Item
          label="Complexity"
          name="editedComplex"
          initialValue={params.get('complex')}
          rules={[{ required: true }]}
        >
          <Select options={gameComplexity} placeholder="Select Complexity" />
        </Form.Item>

        <Form.Item
          label="Retention Depth"
          name="editedRetentionDepth"
          initialValue={params.get('retentionDepth')}
          rules={[{ required: true }]}
        >
          <Select
            options={retentionDepth}
            placeholder="Select Retention Depth"
          />
        </Form.Item>

        <Form.Item
          label="Monetization"
          name="editedMonetizationModel"
          initialValue={params.get('monetizationModel')}
          rules={[{ required: true }]}
        >
          <Select
            options={gameMonetizationModel}
            placeholder="Select Monetization"
          />
        </Form.Item>

        <Form.Item
          label="Game Tier"
          name="editedTier"
          initialValue={params.get('tier')}
          rules={[{ required: true }]}
        >
          <Select options={gameTier} placeholder="Select Tier" />
        </Form.Item>
        <div className="switch-container">
          <label>Enabled</label>
          <Switch checked={enabled} onChange={onChangeSwitch} />
        </div>

        <div className="button-container">
          <Button
            className="edit-img-button"
            onClick={() => document.getElementById('upload-image')?.click()}
          >
            Edit Image
          </Button>
          <input
            id="upload-image"
            type="file"
            hidden
            accept="image/*"
            onChange={handleImageUpload}
          />
          <Button
            className="edit-thumb-button"
            onClick={() => document.getElementById('upload-thumbnail')?.click()}
          >
            Edit Thumbnail
          </Button>
          <input
            id="upload-thumbnail"
            type="file"
            hidden
            accept="image/*"
            onChange={handleThumbImageUpload}
          />
        </div>

        <div className="image-preview">
          <img src={editedImg} alt="Edited" />
          <img src={editedThumbImg} alt="Thumbnail" className="thumb-img" />
        </div>

        <div className="button-container">
          <Button className="save-button" type="primary" onClick={handleSave}>
            Save
          </Button>
          <Button onClick={onCancel}>Cancel</Button>
        </div>
      </Form>
    </div>
  )
}

export default EditTreasureHunter
